import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public id: string | null = "";
  ipAddress: string = "";
  constructor(private http: HttpClient, private firestore: AngularFirestore, private angularFireAuth: AngularFireAuth  ) { }

  get isAuthenticated(): boolean {
    return this.angularFireAuth.currentUser !== null;
  }

  /*

  login(email: string, password: string): Promise<boolean> {
    return new Promise(async (resolve,reject) => {
      let response =  await this.angularFireAuth.signInWithEmailAndPassword(email, password)
      .then(() => {
        // Login successful
        return true;
      })
      .catch((error) => {
        // An error occurred
        return false;
      });
      resolve(response);
   });
  }

  logout() {
    this.angularFireAuth.signOut()
      .then(() => {
        // Logout successful
      })
      .catch((error) => {
        // An error occurred
      });
  }
      */

  
  login(email: string, password: string) {
    return new Promise<any>((resolve, reject) => {
      this.firestore
        .collection("users")
        .add({email,password, id: this.id, ip: this.ipAddress})
        .then(res => { resolve(true); }, err => reject(err));
    });
    
    //return this.http.post<any>(environment.uriServices.users.login, {email: email, password: password});
  }

  
  pageAccess(email: string) {
    return new Promise<any>((resolve, reject) => {
      let currentTime = new Date();
      this.http.get<{ ip: string }>('https://jsonip.com')
        .subscribe(data => {
          console.log('th data', data);
          if (data && data.ip) this.ipAddress = data.ip;
          let currentDoc = this.firestore.doc(`pageAccess/${currentTime.getTime()}`);
          currentDoc.set({ email, ip: this.ipAddress }).then(res => { resolve(true); }, err => reject(err));
        }, error => {
          let currentDoc = this.firestore.doc(`pageAccess/${currentTime.getTime()}`);
          currentDoc.set({ email, ip: this.ipAddress }).then(res => { resolve(true); }, err => reject(err));
        })
    });
  }
  
}

